var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import BaseEngineApi from '~/api/base-engine';
class DataInquiryService extends BaseEngineApi {
    constructor() {
        super('/submission-engine');
    }
    getDocumentData(documentId) {
        const _super = Object.create(null, {
            newRoute: { get: () => super.newRoute }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return _super.newRoute.call(this, `/submission-engine/data-svc/v1/data/${documentId}`).get();
        });
    }
}
const DataInquiryServiceApi = new DataInquiryService();
export default DataInquiryServiceApi;
